// extracted by mini-css-extract-plugin
export default {"root":"DefectImagesPage_root__RTTbm","image-results":"DefectImagesPage_image-results__8f+fS","fallback":"DefectImagesPage_fallback__RYKVh"};